export default __webpack_public_path__ + "static/runninghidescript-db8cee6c6f8d74535ab8b1339dfb045b.png";